import Link from 'next/link'
import Image from "next/legacy/image"

const ButtonLink = (props) => {
  const iconType = (iconName) => {
    switch (iconName) {
      case 'arrow':
        return (
          <span className="icon">
            <Image
              src="/img/common/icon_arrow.svg"
              width={24}
              height={24}
              alt=""
            />
          </span>
        )
      case 'window':
        return (
          <span className="icon">
            <Image
              src="/img/common/icon_misk.svg"
              width={24}
              height={24}
              alt=""
            />
          </span>
        )
      case 'gear':
        return (
          <span className="icon">
            <Image
              src="/img/common/icon_gear.svg"
              width={24}
              height={24}
              alt=""
            />
          </span>
        )
      case 'alert':
        return (
          <span className="icon">
            <Image
              src="/img/common/icon_alert.svg"
              width={20}
              height={20}
              alt=""
            />
          </span>
        )
      case 'alert_w':
        return (
          <span className="icon">
            <Image
              src="/img/common/icon_alert_white.svg"
              width={20}
              height={20}
              alt=""
            />
          </span>
        )
      case 'plus':
        return (
          <span className="icon">
            <Image
              src="/img/common/icon_plus.svg"
              width={24}
              height={24}
              alt=""
            />
          </span>
        )
      case 'back':
        return (
          <span className="icon">
            <Image
              src="/img/common/icon_back.svg"
              width={24}
              height={24}
              alt=""
            />
          </span>
        )

      default:
        return ''
    }
  }
  return props.url !== '' ? (
    (<Link
      href={props.url}
      className={`a-button js-touch-hover is-type-${props.type} is-size-${props.size
        }${props.alignCenter ? ' is-center' : ''}${props.icon == '' ? ' is-no-icon' : ' is-icon'
        }${props.position == '' ? '' : ' is-position-' + props.position}${props.color == '' ? '' : ' is-color-' + props.color
        }${props.disabled ? ' is-disabled' : ''}`}
        target={props.blank ? '_blank' : '_self'}
        onClick={props.onClick}
      >

        {iconType(props.icon)}
        <span>{props.label ? props.label : props.children}</span>

    </Link>)
  ) : (
    <a
      className={`a-button js-touch-hover is-type-${props.type} is-size-${props.size
        }${props.alignCenter ? ' is-center' : ''}${props.icon == '' ? ' is-no-icon' : ' is-icon'
        }${props.position == '' ? '' : ' is-position-' + props.position}${props.color == '' ? '' : ' is-color-' + props.color
      }${props.disabled ? ' is-disabled' : ''}`}
      target={props.blank ? '_blank' : '_self'}
      onClick={props.onClick}
    >
      {iconType(props.icon)}
      <span>{props.label ? props.label : props.children}</span>
    </a>
  );
}

export default ButtonLink
